
import { ReportDesignerV2 } from '@parantion/components'
import {QBtn, QToolbar, QToolbarTitle, QInput, QSpace, QSpinner, QSpinnerHourglass} from 'quasar'
import api from "../../../services/api";

export default {
  name: 'BetaReportDesignerPanel',

  components: {
    ReportDesignerV2, QToolbar, QToolbarTitle, QBtn, QInput, QSpace, QSpinnerHourglass
  },

  data () {
    return {
      isLoading: false,
      isSaving: false,
      initialTemplate: []
    }
  },

  methods: {
    async show (regenerate) {
      await this.$store.dispatch('parantion/data/resetBeforeNewData')
      this.$refs.reportModal.show()
      if (regenerate) {
        // this.regenerate()
      } else {
        const vars = await this.$store.dispatch('parantion/data/getVarsFromTemplate', { templateHash: this.$store.getters['survey/getActiveSurvey'].template })
        await this.$store.dispatch('parantion/data/getFormBulkData', {
          vars: vars,
          formHash: this.$store.state.survey.activeSurvey.fid
        }).then(() => this.initialTemplate = JSON.parse(JSON.stringify(this.template)))
        this.isLoading = false
      }
    },
    showWarningModal () {
      // First check if user has saved and if there are any unsaved changes!
      this.hide()
    },
    showRegenerateConfirm () {
      this.$q.dialog({
        message: this.$t('reportdesigner.regenerateMessage.info'),
        title: this.$t('reportdesigner.regenerate.button'),
        ok: this.$t('reportdesigner.ok.button'),
        cancel: this.$t('generic.cancel.button')
      }).onOk(() => {
        this.regenerate(this.$store.state.parantion.template.templateId, true)
      })
    },
    async regenerate (reportTemplateId, override) {
      this.isLoading = true
      const activeSurvey = await this.$store.getters['survey/getActiveSurvey']
      await this.$store.dispatch('parantion/template/setTemplateId', activeSurvey.template)
      await this.$store.dispatch('parantion/data/resetBeforeNewData')
      const vars = await this.$store.dispatch('parantion/data/getVarsFromTemplate', { templateHash: activeSurvey.template })
      await this.$store.dispatch('parantion/data/getFormBulkData', {
        vars: vars,
        formHash: activeSurvey.fid
      })
      let template = await this.$store.dispatch('parantion/template/getTemplate', activeSurvey.template)
      let report
      if (!override && template.template.child.length > 0) {
        reportTemplateId = template.template.child[0]
        report = JSON.parse((await api.surveyService.getTemplateReportContent(reportTemplateId)).data.content.content)
      } else {
        report = await this.$store.getters['parantion/template/getReportFromForm']()
      }
      await this.$store.dispatch('parantion/template/setReportContentNewAndId', {
        templateId: reportTemplateId || 'new_report',
        content: report
      })
      this.isLoading = false
      this.initialTemplate = JSON.parse(JSON.stringify(this.template))
      this.$toasty.success(this.$t('reportdesigner.regenerateOk.info'))
    },

    async publishContent () {
      await this.$store.dispatch('parantion/template/designer/setActiveElement', '')
      this.isSaving = true
      const templateId = this.$store.state.parantion.template.templateId
      let response
      if (templateId !== 'new_report') {
        response = await api.surveyService.setFormTemplateContent(templateId, JSON.stringify(this.template))
      } else {
        const activeSurvey = await this.$store.getters['survey/getActiveSurvey']
        response = await api.surveyService.postReportTemplate({
          parent: activeSurvey.template,
          content: JSON.stringify(this.template),
          label: activeSurvey.frm_label
        })
        if (response.tid) {
          await this.$store.dispatch('parantion/template/setReportContentAndId', {
            templateId: response.tid,
            content: this.template
          })
        }
      }
      if (response.status && (response.status === 200 || response.tid)) {
        this.$toasty.success(this.$t('reportdesigner.report_saved.msg'))
        this.initialTemplate = JSON.parse(JSON.stringify(this.template))
      } else {
        this.$toasty.error(this.$t('errors.error.msg'))
      }
      this.isSaving = false
    },
    hideProcedure () {
      this.$refs.reportModal.hide()
    },

    async hide () {
      if (this.$store.state.parantion.template.designer.activeElement) this.$store.commit('parantion/template/UPDATE_ELEMENT', this.$store.state.parantion.template.designer.activeElement, { root: true })
      // const template = JSON.parse(JSON.stringify(this.template))
      // if (!isEqual(template, this.initialTemplate)) {
      //   this.$refs.warning_save_dialog.show()
      // } else {
        this.hideProcedure()
      // }
    }
  }
}
